export const getFileAvailabilityInitialised = state => state.fileAvailability.initialisedFileAvailability;

export const getDefaultFilters = state => state.fileAvailability.defaultFilters;

export const getFilterDefinitions = state => state.fileAvailability.filterDefinitions;
export const getFileAvailabilityLastUpdated = state => state.fileAvailability.lastUpdatedFileAvailability;
export const getDefaultSort = state => (
    state.fileAvailability.gridSorting
);
export const getDateFrom = (state) => {
    if (state) {
        const filter = state.find(obj => obj.definition.id === 'runDate');
        if (filter && filter.value) {
            return filter.value.from;
        }
    }
    return null;
};
export const getDateTo = (state) => {
    if (state) {
        const filter = state.find(obj => obj.definition.id === 'runDate');
        if (filter && filter.value) {
            return filter.value.to;
        }
    }
    return null;
};